import React from 'react';
import './FormSelect.css';

/**
 * Reusable FormSelect component for dropdown selections
 * @param {string} label - Field label
 * @param {string} name - Select name
 * @param {string} value - Selected value
 * @param {function} onChange - Change handler
 * @param {array} options - Array of {label, value} objects
 * @param {boolean} required - Whether field is required
 * @param {string} error - Error message
 * @param {string} placeholder - Placeholder option text
 */
const FormSelect = ({
  label,
  name,
  value,
  onChange,
  options = [],
  required = false,
  error = '',
  placeholder = 'Select an option',
  disabled = false,
}) => {
  return (
    <div className="form-select">
      {label && (
        <label htmlFor={name} className="form-select-label">
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      <select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
        className={`form-select-control ${error ? 'error' : ''}`}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <span className="form-select-error">{error}</span>}
    </div>
  );
};

export default FormSelect;
